import styles from "./cell.module.scss";
import { Skeleton } from "../../skeleton";
import { Cell, CoreCellProps } from "./cell";
import { Tooltip, TooltipContent, TooltipTrigger } from "../../Tooltip";
import { useRef } from "react";
import * as date from "date-fns";

export interface DateCellProps extends CoreCellProps {
  value: Date | string | undefined;
  /** The format the date should be displayed in.
   * Syntax can be found here: https://date-fns.org/v2.16.1/docs/format
   * @default MM/dd/yyyy (09/09/2024)*/
  format?: string;
}

export const CellDate = ({
  value,
  format = "MM/dd/yyyy",
  showTooltip = true,
  ...rest
}: DateCellProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLDivElement>(null);

  const isTextOverflown =
    containerRef.current && textRef.current
      ? textRef.current.clientWidth > containerRef.current.clientWidth
      : false;

  const formattedValue =
    typeof value === "string" ? new Date(value) : value ?? null;
  const formattedDate = formattedValue
    ? date.format(formattedValue, format)
    : null;

  return (
    <>
      <Cell
        alignment="right"
        skeleton={<Skeleton style={{ width: 32 }} />}
        {...rest}
      >
        {formattedDate !== null && formattedDate !== undefined && (
          <div ref={containerRef} className={styles.cellContent}>
            {/*
              This text does not get displayed!
              This element will determine if the text width is greater than the container width.
              Which will ultimately display a tooltip if so. 
            */}
            <div
              ref={textRef}
              className={styles.tooltipTriggerText}
              aria-hidden
            >
              {formattedDate}
            </div>

            {!isTextOverflown || !showTooltip ? (
              <>{formattedDate}</>
            ) : (
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className={styles.cellContent}>{formattedDate}</div>
                </TooltipTrigger>

                <TooltipContent variant="small" align="center" side="left">
                  {formattedDate}
                </TooltipContent>
              </Tooltip>
            )}
          </div>
        )}
      </Cell>
    </>
  );
};
